import { ReactComponent as Edit } from 'assett/icons/edit.svg';
import { ReactComponent as Trash } from 'assett/icons/trash_icon.svg';
import {
	hideClaimCommentSection,
	showClaimCommentSection,
	updateClaimComment,
} from 'feature/claims/claimSlice';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import { Box, Button, IconButton, Stack, TextField, Typography } from 'styles';
import { CLAIM_COMMENT_MAX_LENGTH, TRANSLATION_KEYS } from 'utils/constants';

const ClaimComments = () => {
	const dispatch = useDispatch<AppDispatch>();
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const { claimData, showClaimComment } = useSelector(
		(store: RootState) => store.claim,
	);
	const [comment, setComment] = useState(claimData.comments ?? '');

	useEffect(() => {
		if (showClaimComment) {
			setComment(claimData.comments ?? '');
		}
	}, [showClaimComment, claimData.comments]);

	const handleCancel = () => {
		setComment(claimData.comments ?? '');
		dispatch(hideClaimCommentSection());
	};

	const handleChangeComment = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.value.length > CLAIM_COMMENT_MAX_LENGTH) {
			return;
		}

		setComment(event.target.value);
	};

	const handleConfirm = () => {
		dispatch(updateClaimComment({ comments: comment }));
	};

	const handleClickEdit = () => {
		dispatch(showClaimCommentSection());
	};

	const handleClickDelete = () => {
		dispatch(updateClaimComment({ comments: null }));
	};

	return (
		<Stack direction={'row'} pt={'20px'} gap={'20px'}>
			{!showClaimComment && claimData.comments && (
				<Stack direction={'row'} gap={'10px'} flex={1} alignItems={'baseline'}>
					<Typography variant="bodyLink" textTransform={'uppercase'}>
						{tClientLabels('claim.comments.title')}
					</Typography>
					<Typography variant="body">{claimData.comments}</Typography>
					<Stack direction={'row'} gap={'10px'} ml={'auto'}>
						<IconButton onClick={handleClickDelete}>
							<Trash />
						</IconButton>
						<IconButton onClick={handleClickEdit}>
							<Edit width={18} height={18} />
						</IconButton>
					</Stack>
				</Stack>
			)}

			{showClaimComment && (
				<>
					<Stack flex={1}>
						<TextField
							label={tClientLabels('claim.comments.label')}
							fullWidth
							onChange={handleChangeComment}
							value={comment ?? ''}
						/>
						<Box sx={{ pl: '16px' }}>
							<Typography variant="caption">
								{tClientLabels('claim.comments.length', {
									count: comment?.length ?? 0,
									max: CLAIM_COMMENT_MAX_LENGTH,
								})}
							</Typography>
						</Box>
					</Stack>
					<Button variant="outlined" onClick={handleCancel}>
						{tClientLabels('commons.buttons.cancel')}
					</Button>
					<Button
						variant="contained"
						disabled={!comment?.length}
						onClick={handleConfirm}
					>
						{tClientLabels('commons.buttons.confirm')}
					</Button>
				</>
			)}
		</Stack>
	);
};

export default ClaimComments;
